var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PersonProfile",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-person-profile","viewBox":"0 0 500 500"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M28.1 475v-48.4c0-15.9 25.7-29.1 34.9-32.6 4.6-1.5 60.5-19.6 105.3-36.5 19-7.2 32.1-18.7 39-34.1 10.5-23.3 2.3-46.1 1.4-48.7l-.8-2.1-1.4-1.8c-10.8-13.2-25.3-34.2-27.3-37.1-25.7-43.2-10.6-99.2-10.4-99.8l.2-.8.1-.8c5.8-36.4 21.4-60.7 46.3-72.3 19-8.8 36.9-7 37-6.9l.7.1h.7c30.3.7 53.3 14.5 68.2 41 11.9 21.1 14.3 42.6 14.3 42.7l.1 1 .2.9c11.9 49-5.4 84.3-5.6 84.6l-.4.8c-7 15.9-25.8 38.7-32.5 46.1l-1.2 1.3-.8 1.6c-10.1 19.5-9.4 39.2 1.9 55.6 8.1 11.7 18.8 17.7 20 18.4l.9.5L426 387.2l.6.2c42.3 13.4 45.2 34.9 45.4 36.8V475h28v-51.1c0-2.1-.4-13-9.3-26.2-10.9-16.3-29.5-28.7-55.3-36.9l-104.7-38.5c-1.6-1-6.2-4.3-9.6-9.2-5.2-7.5-5.5-15.6-.8-25.4 5.6-6.3 26.8-31.2 35.9-51.8 2.5-5.1 21.3-46.2 7.8-102.7-.7-5.2-4.2-28.3-17.1-51.7-19.7-35.6-51.5-55-92-56.1-4.5-.4-26.4-1.7-50 8.8-42.9 19.1-58.2 61.1-63.5 93.2-2.2 8.3-16.9 70.2 13.8 121.3l.4.7c.6.9 15.2 22.2 27.2 37.2 1.1 4.2 3.3 15.3-1.3 25.5-3.8 8.4-11.6 14.9-23.4 19.4-45.8 17.4-103.6 35.9-104.2 36.1l-.5.2c-5.5 2-53.6 20.6-53.6 59V475h28.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/person-profile.svg